// extracted by css-extract-rspack-plugin
export default {"userPageContainer":"UsersPage_userPageContainer__k6wnW","userPageHeader":"UsersPage_userPageHeader__17W0P"};